<template>
  <div class="account-right fixed-mp-cls">
    <history-bread-crumb />
    <div class="account-card schedule-detail">
      <div class="account-header">
        <div class="back-arrow">
          <router-link class="d-sm-none" :to="{ name: 'profile.history' }">
            <img
              src="/images/svg/global/left_arrow.svg"
              class="img-fluid"
              alt=""
            />
          </router-link>
        </div>
        <h4>{{ _T('My Order History') }}</h4>
      </div>
      <Loader v-show="processInProgress(process)" />
      <div
        class="account-body dine-in-details history-details"
        v-if="selected_order"
      >
        <template>
          <history-common-header :order="selected_order" />
          <history-horizonal-header :order="selected_order" />
          <!-- <HistoryDinningHeader :order="order" /> -->
          <!-- <HistoryMapHeader :order="selected_order" /> -->
          <order-items
            :order-items="selected_order.items"
            :item-modifiers="selected_order.item_modifiers"
            :item-discounts="selected_order.item_discounts"
          />
          <order-price-details :order="selected_order" />
          <history-footer />
        </template>
        <template v-if="!selected_order && !processInProgress(process)">
          <h5>{{ _T('No Order Found') }}</h5>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import OrderItems from '../Order/OrderItems'
import HistoryCommonHeader from './Headers/HistoryCommonHeader'
import HistoryHorizonalHeader from './Headers/HistoryHorizonalHeader'
// TODO: Dine in orders not supported in 1st phase, Will uncomment this in next phase
// import HistoryDinningHeader from './Headers/HistoryDinningHeader'
// import HistoryMapHeader from './Headers/HistoryMapHeader'
import HistoryBreadCrumb from '../History/HistoryBreadCrumb'
import OrderPriceDetails from '../Order/OrderPriceDetails'
import HistoryFooter from './HistoryFooter'
import { mapGetters } from 'vuex'
import { Item } from '@/helpers/Item'

import Loader from '@/components/Elements/Loader.vue'
export default {
  name: 'OrderHistory',
  components: {
    OrderItems,
    HistoryCommonHeader,
    HistoryHorizonalHeader,
    // HistoryMapHeader,
    // HistoryDinningHeader,
    HistoryBreadCrumb,
    OrderPriceDetails,
    HistoryFooter,
    Loader,
  },
  data () {
    return {
      process: 'load-order',
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      'all_customer_orders',
      'selected_order',
      'processInProgress',
    ]),
  },
  beforeMount () {
    let orderId = this.$route.params.order_id

    this.$store.dispatch(
      'startProcess',
      {
        process: this.process,
        progress: true,
      },
      { root: true }
    )
    this.$store
      .dispatch('getOrderById', orderId)
      .then(() => {})
      .finally(() => {
        this.$store.dispatch('stopProcess', this.process)
      })
  },
  async beforeRouteLeave (to, from, next) {
    if (to.name.includes('store_page')) {
      this.$store.commit('CLEAR_CHECKOUT')
      await Item.clearCart()
      const that = this
      that.$store
        .dispatch('reAddItemsToCart', that.selected_order.items)
        .then(() => {
          next()
        })
    } else {
      next()
    }
  },
}
</script>
<style lang="scss" scoped>
.account-card {
  box-shadow: 0px 4px 34px rgba($black, 0.07);
  margin: $px18 0 $px30;
  border-radius: $px10;
  @media (max-width: 575px) {
    margin: 0 !important;
  }
  .account-header {
    .back-arrow {
      @media (max-width: 575px) {
        position: absolute;
        top: $px18;
        left: $px20;
        z-index: 1;
      }
    }
    border-bottom: $px1 solid $dark-border;
    padding: $px16 $px50;
    @media (max-width: 575px) {
      display: flex;
      justify-content: space-between;
      align-content: space-between;
    }

    h4 {
      font-weight: 600;
      margin-bottom: 0;
    }
  }
}
.dine-in-details {
  padding: $px30 $px40 $px40;

  @media (max-width: 1199px) {
    padding: $px20 $px30 $px30;
  }

  @media (max-width: 991) {
    padding: $px20;
  }
}
</style>
